(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/api/assets/javascripts/fetch-winners.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/api/assets/javascripts/fetch-winners.js');
"use strict";


let logger;
let jupiter;
let svsFetch;
let svsFetchSetup;
let feature;
if (svs.isServer) {
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  logger = trinidad.logger('module:bingo_react:components:api:fetchWinners');
  jupiter = trinidad.jupiter;
  svsFetchSetup = trinidad.svsFetch;
} else {
  logger = svs.core.log.getLogger('module:bingo_react:components:api:fetchWinners');
  jupiter = svs.core.jupiter;
  svsFetch = svs.core.svsFetch.create();
  feature = svs.core.detect.feature;
}
const fetchWinners = async req => {
  if (svs.isServer && req) {
    feature = req.feature;
  }
  if (!(await feature('ft-use-casino-cloud-apis'))) {
    try {
      const fetchOptions = {
        method: 'GET',
        path: '/casino/1/winnerfeed/bingo',
        req
      };
      const result = await jupiter.callAsync(fetchOptions);
      const winners = result.winnerFeed.items;
      return winners;
    } catch (e) {
      logger.error("Error fetching winners ".concat(e), req);
      throw e;
    }
  }
  try {
    if (svs.isServer && svsFetchSetup) {
      svsFetch = svsFetchSetup(req);
    }
    const path = '/v1/casino/winnerfeeds/bingo';
    const resp = await svsFetch(path);
    const data = await resp.json();
    return data.winnerFeed;
  } catch (error) {
    logger.error("Error fetching winners ".concat(error === null || error === void 0 ? void 0 : error.message), req);
    throw error;
  }
};
if (svs.isServer) {
  module.exports = fetchWinners;
} else {
  setGlobal('svs.bingo_react.components.api.fetchWinners', fetchWinners);
}

 })(window);